import React, { useRef, useState } from 'react';
import { Paperclip, Trash2, Loader2, Upload } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { useLang, tx } from '../../i18n/LanguageContext';

export const AttachmentsManager = ({ courseId, lessonId, attachments, onChange }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post(`/courses/${courseId}/lessons/${lessonId}/attachments`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange([...attachments, data]);
      toast.success(L('تم رفع المرفق', 'Attachment uploaded'));
    } catch (e) { toast.error(e?.response?.data?.detail || L('تعذر الرفع', 'Upload failed')); }
    finally { setBusy(false); }
  };
  const remove = async (a) => {
    await api.delete(`/courses/${courseId}/lessons/${lessonId}/attachments/${a.id}`);
    onChange(attachments.filter(x => x.id !== a.id));
  };
  return (
    <div data-testid="attachments-manager" className="space-y-2">
      <div className="text-xs font-bold text-slate-600">{L('مرفقات الدرس', 'Lesson attachments')}</div>
      {attachments.map(a => (
        <div key={a.id} className="flex items-center gap-2 rounded-lg bg-slate-50 border border-slate-200 px-3 py-2 text-sm">
          <Paperclip className="w-4 h-4 text-blue-600" /><span className="flex-1 truncate" dir="auto">{a.name}</span>
          <button type="button" data-testid={`attachment-delete-${a.id}`} onClick={() => remove(a)} className="text-rose-500"><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
      <button type="button" data-testid="attachment-upload-btn" disabled={busy} onClick={() => ref.current?.click()}
        className="w-full h-10 rounded-lg border-2 border-dashed border-slate-200 hover:border-blue-300 text-slate-600 text-xs font-bold inline-flex items-center justify-center gap-2">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}{L('رفع ملف (PDF، مشروع، صور...)', 'Upload file (PDF, project, images...)')}
      </button>
      <input ref={ref} type="file" hidden data-testid="attachment-file-input" onChange={e => { const f = e.target.files?.[0]; if (f) upload(f); e.target.value = ''; }} />
    </div>
  );
};
